import React from 'react';
import { useNavigate } from 'react-router-dom';
import NuvvyDrinkExperience from '../../../../../components/NuvvyDrinkExperience';
import { approveDrink, makeDrinkUser } from '../../../../../services/Clint/AiAgentApi';
import { rateDrink } from '../../../../../services/Clint/UserOrdersApi';

const Makedrinkpage = () => {
  const navigate = useNavigate();

  return (
    <NuvvyDrinkExperience
      makeDrinkRequest={makeDrinkUser}
      approveDrinkRequest={approveDrink}
      rateDrinkRequest={rateDrink}
      backPath="/clint/make-order"
      approvedNavigatePath="/clint/make-order"
      approveSource="local_screen"
      title="إنشاء مشروبك الخاص"
      subtitle="خلّي Nuvvy يساعدك تصمم مشروب على مزاجك"
      enableRating
      onNavigate={navigate}
    />
  );
};

export default Makedrinkpage;
